export default __webpack_public_path__ + "static/media/FIAssembly-01.fbcee6cb.png";